import { render } from "./buy-again.vue?vue&type=template&id=7828c4de&scoped=true"
import script from "./buy-again.vue?vue&type=script&lang=js"
export * from "./buy-again.vue?vue&type=script&lang=js"

import "./buy-again.vue?vue&type=style&index=0&id=7828c4de&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7828c4de"]])

export default __exports__